window.showPassword = function (clicked_id) {
  const input_password = document.getElementById(clicked_id);
  const type = input_password.getAttribute('type') === 'password' ? 'text' : 'password';
  input_password.setAttribute('type', type);
}
